<!--
 * @Author: dingguowei
 * @Date: 2023-06-13 15:10:28
 * @LastEditors: dingguowei
 * @LastEditTime: 2023-07-03 18:18:22
-->
<!-- 用户领取任务详情 -->
<template>
  <div class="taskdetails">
    <el-card class="left">
      <p class="title">文章详情</p>
      <div
        class="body"
        v-html="taskData.description ? taskData.description : ''"
      ></div>
    </el-card>
    <el-card class="right">
      <p class="title">任务详情</p>
      <div class="head">
        <p style="font-size: 0.9rem; font-weight: 600">{{ taskData.title }}</p>
        <p style="font-size: 0.7rem; color: #999999">
          截止日期:{{ taskData.endAt }}
        </p>
      </div>
      <div class="body">
        <el-tabs v-model="activeName">
          <el-tab-pane
            label="详细描述"
            name="详细描述"
            style="height: 100%; position: relative"
          >
            <div style="height: 100%; display: flex; flex-direction: column">
              <div
                class="card"
                v-for="(item, index) in taskData.salaryListVos"
                :key="index"
              >
                <p style="font-size: 0.8rem">
                  {{ item.type === 0 ? "基本任务要求" : "附加任务要求" }}
                </p>
                <div class="cardbody">
                  <div
                    class="carditem"
                    v-for="(carditem, index) in card_item"
                    :key="index"
                  >
                    <p style="font-size: 0.9rem; color: #5874ef">
                      {{ item[carditem.fieId] ? item[carditem.fieId] : "-" }}
                    </p>
                    <p style="font-size: 0.9rem">{{ carditem.name }}</p>
                  </div>
                </div>
              </div>
              <div style="margin-top: auto; text-align: right">
                <el-button
                  style="color: #fff"
                  :style="{
                    backgroundColor:
                      userStatus !== null ? '#999999' : '#5874ef',
                  }"
                  size="mini"
                  :disabled="userStatus !== null"
                  @click="userSave"
                  >{{ statusText(userStatus) }}</el-button
                >
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="任务进度" name="任务进度">
            <task_tabs_result
              :mission-receive-id="missionReceiveId"
              :task-info="taskData"
              :salary-list-vos="taskData.salaryListVos"
              :img-url="taskData"
            ></task_tabs_result>
          </el-tab-pane>
          <el-tab-pane
            label="审批结果"
            name="审批结果"
            style="height: 100%"
            v-if="userStatus === 'REFUSED' || userStatus === 'FORBID'"
          >
            {{ endorse }}
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
  </div>
</template>
  
  <script>
import task_tabs_details from "@/components/task/task_tabs_details.vue";
import task_tabs_result from "@/components/task/task_tabs_result.vue";
import store from "@/store";
import user_submit from "@/components/user/user_submit.vue";
import { mapState } from "vuex";
import { gettaskInfo, usersave, getauditresult } from "@/api/user";
import user_submitVue from "@/components/user/user_submit.vue";
export default {
  components: {
    task_tabs_result,
  },
  data() {
    return {
      taskData: [],
      activeName: "详细描述",
      card_item: [
        {
          name: "互动数",
          fieId: "totalNum",
          showDivder: true,
        },
        {
          name: "点赞数",
          fieId: "likeNum",
          showDivder: true,
        },
        {
          name: "收藏数",
          fieId: "collectNum",
          showDivder: true,
        },
        {
          name: "评论数",
          fieId: "commentNum",
          showDivder: true,
        },
        {
          name: "转发数",
          fieId: "shareNum",
        },
      ],
      endorse: "",
    };
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.gettaskInfo();
    });
  },
  watch: {
    userStatus: {
      handler(newvalue) {
        if (newvalue === "FORBID" || newvalue === "REFUSED") {
          this.getauditresult();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState("task", ["taskInfo"]),
    userStatus() {
      return store.state.user.userCurTaskStatus;
    },
    missionReceiveId() {
      return store.state.task.taskInfo.missionReceiveId;
    },
    statusText() {
      return function (val) {
        if (val === "TOJUDGE") {
          return "待审核";
        } else if (val === "CLOSED") {
          return "已关闭";
        } else if (val === "FINISHED") {
          return "已通过";
        } else if (val === "REFUSED") {
          return "被拒绝";
        } else if (val === "FORBID") {
          return "被拉黑";
        } else if (val === "TOFINISH") {
          return "进行中";
        } else {
          return "领取任务";
        }
      };
    },
  },
  methods: {
    async gettaskInfo() {
      await gettaskInfo({
        missionId: this.taskInfo.missionId,
      }).then((res) => {
        this.taskData = res.data;
      });
    },
    userSave() {
      usersave({
        missionId: this.taskInfo.missionId,
        missionPublisherAccount: this.taskInfo.publisherAccount,
        missionPublisherId: this.taskInfo.publisherId,
      }).then((res) => {
        if (res.data !== null) {
          store.commit("task/CHANGE_missionReceiveId", res.data.id);
          store.commit("user/CHANGE_userCurTaskStatus", 0);
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      });
    },
    getauditresult() {
      getauditresult({
        missionReceiveId: this.taskInfo.missionReceiveId,
      }).then((res) => {
        this.endorse = res.data.endorse;
      });
    },
  },
};
</script>
  <style lang="scss" scoped>
.taskdetails {
  padding: 1rem 2rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;

  .title {
    font-size: 0.8rem;
  }

  ::v-deep .el-card__body {
    height: 100%;
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
  }

  .left {
    flex: 1;
    margin-right: 10px;

    .body {
      flex: 1;
      box-sizing: border-box;
      padding: 10px 0 0 0;
      overflow: auto;
    }
  }

  .right {
    width: 26rem;

    ::v-deep .el-tabs {
      height: 100% !important;
      overflow: auto;
      display: flex;
      flex-direction: column;
    }

    ::v-deep .el-tabs__content {
      flex: 1;
      width: 100%;
      overflow: auto;
    }

    ::v-deep .el-tabs__item {
      font-size: 0.8rem;
    }

    .head {
      padding: 10px 0 0 0;
      line-height: 160%;
    }

    .body {
      flex: 1;
      overflow: auto;
      .cardbody {
        display: flex;
        text-align: center;
        justify-content: space-between;
        margin: 10px 0;
        line-height: 140%;

        .carditem {
          flex: 1;
        }
      }
    }
  }
}
</style>